var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loadingIndex"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"rect1"}),_c('div',{staticClass:"rect2"}),_c('div',{staticClass:"rect3"}),_c('div',{staticClass:"rect4"}),_c('div',{staticClass:"rect5"})]),_c('div',{staticClass:"loadingtext"},[_vm._v("\n      正在载入页面中...."),_c('br'),_vm._v("若无法打开请刷新重试\n    ")])])])
}]

export { render, staticRenderFns }